import { createRef } from 'react';
import config from 'config';
import isUndefined from 'lodash/isUndefined';

import { GeoLocation } from '@/types/schema';

const containerRef = createRef<HTMLDivElement>();

function useLocationImage({ geoLocation }: { geoLocation?: GeoLocation }) {
  if (isUndefined(geoLocation?.latitude) || isUndefined(geoLocation?.longitude)) {
    return {};
  }

  return {
    locationImageUrl: `https://maps.googleapis.com/maps/api/staticmap?size=600x300&zoom=17&scale=2&markers=${geoLocation?.latitude},${geoLocation?.longitude}&key=${config.google.maps_api_key}`,
    containerRef,
  };
}

export default useLocationImage;
